import dev from './dev';
import production from './production';
import testing from './testing';
import staging from './staging';
import sandbox from './sandbox';
import devTesting from './devTesting';
import storage from 'conversional-persistent-storage';

function getEnvironment(){
  try {
    if (location.hostname.includes('partners-sandbox'))
      return sandbox
  } catch (e){

  }
  // @ts-ignore
  switch (BACKOFFICE_ENV){
    case "dev": return dev;
    case "staging": return staging;
    case "production": return production;
    case "testing": return testing;
    case "devTesting": return devTesting;
  }
    return production
}

export const getRootUrl = () => {
  const env = getEnvironment()
  return env.ENV === 'development' ? storage.getItem('rootApiUrl', undefined, 'localStorage') || env.ROOT_URL : env.ROOT_URL
}

export default getEnvironment()
